import connect from 'components/shared/connect'
import { mapResponse } from 'front-end-core/helpers/dataflow'
import dayjs from 'dayjs'
import { DATE_FORMAT } from 'constants/locale'
import { requestGroup } from 'services/CurrentAwarenessService'
import CaAccordionWrapper from 'pages/currentawareness/CaAccordionWrapper'
import { map } from 'rxjs/operators'

const ConnectedCaAccordion = connect(
  ({ fromDate, toDate, searchPhrase, flavour, id, aol }) => {
    toDate = toDate
      ? dayjs(toDate)
        .add(1, 'day')
        .format(DATE_FORMAT)
      : null

    return requestGroup({ fromDate, toDate, searchPhrase, flavour, id, aol })
      .pipe(map(mapResponse(group => ({ group }))))
  }
)(CaAccordionWrapper)

export default ConnectedCaAccordion
